import { render, staticRenderFns } from "./ProjectSegmentationTitle.vue?vue&type=template&id=16016f4e&"
import script from "./ProjectSegmentationTitle.vue?vue&type=script&lang=js&"
export * from "./ProjectSegmentationTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports